// extracted by mini-css-extract-plugin
module.exports = {"slideImage":"_1D1zSBr3DU0fAn1XTkYYgy","sliderWrapper":"_1Br0ZyHG6pRNAnrPpV9sIL","slide":"_1cZgxHFaGITmXig3A9HVKN"};